
const init = () => {
    convertUtcDatesToLocal();
}

const convertUtcDatesToLocal = () => {
    $("span.js-local-date").each(
        function () {

            // Dates expected to be in "M/dd/yyyy h:mm tt UTC" format
            const {
                date,
                startDate,
                endDate,
                displayTime
            } = this.dataset;

            if (!!date) {
                const formatParameters = displayTime
                    ? { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }
                    : { month: 'long', day: 'numeric', year: 'numeric' };
                $(this).text(new Date(date).toLocaleString('default', formatParameters));
            } else {
                if (!startDate || !endDate) return;

                var localStartDate = new Date(startDate);
                var localEndDate = new Date(endDate);

                $(this).text(getFormattedDate(localStartDate, localEndDate));
            }
        }
    );
}

const getFormattedDate = (startDate, endDate) => {
    if (startDate.getFullYear() !== endDate.getFullYear()) {
        const formatParameters = { month: 'long', day: 'numeric', year: 'numeric' };
        const startDateString = startDate.toLocaleString('default', formatParameters);
        const endDateString = endDate.toLocaleString('default', formatParameters);
        return startDateString + " - " + endDateString;
    } else {
        if (startDate.getMonth() !== endDate.getMonth()) {
            const startDateString = startDate.toLocaleString('default', { month: 'long', day: 'numeric' });
            const endDateString = endDate.toLocaleString('default', { month: 'long', day: 'numeric', year: 'numeric' });
            return startDateString + " - " + endDateString;
        } else {
            const startDateString = startDate.toLocaleString('default', { month: 'long', day: 'numeric' });
            const endDateString = endDate.getDate() + ", " + endDate.getFullYear();
            return startDateString + " - " + endDateString;
        }
    }
}

export default init;